import type { PageExperience } from '@/features/experiences/types';
import { Box, Flex, Text } from '@/ui';
import { FONT_HEADING, FONT_TEXT } from '../../../css/customFonts';
import { Logo } from './Logo';

type Props = {
  experience: PageExperience;
  measureKey?: string;
};

export const Footer = ({ experience, measureKey }: Props) => {
  const owner = experience.owner?.name;

  return (
    <Flex
      alignItems="center"
      data-measure={measureKey}
      justifyContent="space-between"
      opacity={0.3}
      pt="0.75em"
    >
      <Box>
        {owner && (
          <Text
            fontFamily={FONT_TEXT}
            fontSize="0.7em"
            fontWeight="500"
            letterSpacing="0.1em"
            overflow="hidden"
            textOverflow="ellipsis"
            textTransform="uppercase"
            whiteSpace="nowrap"
          >
            Created for {owner}
          </Text>
        )}
      </Box>
      <Flex
        alignItems="center"
        flexDirection="row"
        fontFamily={FONT_HEADING}
        justifyContent="center"
      >
        <Logo height="1.25em" />
      </Flex>
    </Flex>
  );
};
